module["exports"] = [
  "#{city_prefix}#{city_suffix}",
  "#{city_prefix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/address/city.js
// module id = 844
// module chunks = 0